import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../i18n/LanguageContext";
import "../styles/Footer.css";

function Footer() {
  const { t } = useLanguage();

  const socials = [
    { name: "X (Twitter)", url: "https://x.com/FrostWyrmStd", icon: "/images/icons/twitter.png" },
    { name: "Bluesky", url: "https://bsky.app/profile/frostwyrmstudio.bsky.social", icon: "/images/icons/bluesky.png" },
    // Links to the account that matches the site language
    { name: t.footer.instagram, url: t.social.instagram, icon: "/images/icons/instagram.png" },
  ];

  return (
    <footer className="footer">
      <div className="footer-inner">
        <button
          className="scroll-to-top"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          aria-label={t.footer.backToTop}
          title={t.footer.backToTop}
        >
          <img src="/images/logo/icone.png" alt="" />
        </button>

        <nav className="footer-links">
          <Link to="/about">{t.nav.about}</Link>
          <Link to="/contact">{t.nav.contact}</Link>
        </nav>

        <div className="footer-socials">
          {socials.map((social) => (
            <a
              key={social.icon}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={social.name}
              title={social.name}
            >
              <span className="mask-icon" style={{ "--icon": `url(${social.icon})` }} />
            </a>
          ))}
        </div>
      </div>

      <p className="footer-copy">
        © {new Date().getFullYear()} Frost Wyrm Studios. {t.footer.rights}
      </p>
    </footer>
  );
}

export default Footer;
